import { API_URL, BRAND_ENDPOINT } from "../helpers/constants";
import { bigCommerceApi } from "../helpers/fetchWrapper";

export const getBrands = async () => {
  const brandsUrl = `${API_URL}/${process.env.BIGCOMMERCE_STORE_HASH}/${BRAND_ENDPOINT}?limit=250`;
  try {
    const data = await bigCommerceApi(brandsUrl);
    return data;
  } catch (e) {
    console.error({ error: e, origin: "getBrands" });
  }
};

export const getBrandById = async (brand_id) => {
  const brandsUrl = `${API_URL}/${process.env.BIGCOMMERCE_STORE_HASH}/${BRAND_ENDPOINT}/${brand_id}`;
  try {
    const data = await bigCommerceApi(brandsUrl);
    return data;
  } catch (e) {
    console.error({ error: e, origin: "getBrandById" });
  }
};
